export default __webpack_public_path__ + "static/media/logo-wide-meetinga.54e6fa50.svg";